import * as t from 'ts-codec';
import { GroupResource } from '../types/types-groups.js';
import { PaginatedRequest, PaginatedResponse } from './pagination.js';
export var ApiGroupRoutes;
(function (ApiGroupRoutes) {
    ApiGroupRoutes["GET_MY_GROUP_STATUS"] = "/api/v1/groups/get-my-status";
    ApiGroupRoutes["GET_GROUP"] = "/api/v1/groups/get";
    ApiGroupRoutes["GET_GROUPS"] = "/api/v1/groups/get-all";
    ApiGroupRoutes["CREATE_GROUP"] = "/api/v1/groups/create";
    ApiGroupRoutes["JOIN_GROUP"] = "/api/v1/groups/join";
    ApiGroupRoutes["LEAVE_GROUP"] = "/api/v1/groups/leave";
})(ApiGroupRoutes || (ApiGroupRoutes = {}));
export const GetGroupsRequest = PaginatedRequest.and(t.object({
    search: t.string.optional()
}));
export const GroupsResponse = PaginatedResponse(GroupResource);
